import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from 'lodash-es/defaultsDeep';
import { DfsDirective } from './atomic/dfs-directive';
import { DfsScopeDirective } from './atomic/dfs-scope-directive';
import { NDfs } from './dfs.interfaces';

let scope = 0;
@NgModule({
    declarations: [DfsDirective, DfsScopeDirective],
    exports: [DfsDirective, DfsScopeDirective]
})
export class DragonflyStylesModule {
    static forChild(options?: Partial<NDfs.IOptions>): ModuleWithProviders<DragonflyStylesModule> {
        return {
            ngModule: DragonflyStylesModule,
            providers: [
                {
                    provide: NDfs.OPTIONS,
                    // multi: true,
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    useFactory: () => {
                        const defaultOptions: Partial<NDfs.IOptions> = {
                            distanceQuant: ['4px', '4px', '4px', '4px'],
                            layout: {
                                gridGutter: ['12px', '24px', '40px', '48px'],
                                gridSize: 12
                            },
                            scope: options?.scope || `scope${scope++}`
                        };
                        return defaultsDeep(options || {}, defaultOptions);
                    }
                }
            ]
        };
    }
}
